/**
 * The failure that carries data the screen has to show.
 *
 * Kept apart from `OptInFeatures.service.ts` so the removable mock can raise it without importing
 * the service that imports it — the same arrangement the Surveys module uses.
 *
 * @module Pages/BUs/OptInFeatures
 */

/**
 * `409` on create: the key is held by a feature that was **deleted**, not by a live one.
 *
 * It carries the deleted feature's id and date because the only useful answer to this conflict is
 * an offer to restore that row — the key cannot be reused while it exists, and the listing hides it
 * by default. A live feature holding the key raises a plain `Error`: there is nothing to offer.
 */
export class OptInKeyHeldByDeletedError extends Error {
  readonly deletedFeatureId: string;
  readonly deletedAt: string | null;

  constructor(message: string, deletedFeatureId: string, deletedAt: string | null) {
    super(message);
    this.name = 'OptInKeyHeldByDeletedError';
    this.deletedFeatureId = deletedFeatureId;
    this.deletedAt = deletedAt;
  }
}
